import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import CopyButton from './CopyButton';
import { buttonClass, fieldClass, labelClass, mutedClass, tabClass } from '../uiStyles';

const INDENTS = [2, 4];
const SAMPLE = '{"ism":"Doston","kasb":"dasturchi","tillar":["PHP","JavaScript"],"tajriba":{"yil":8}}';

const JsonFormatter = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const [text, setText] = useState('');
  const [indent, setIndent] = useState(2);
  const [status, setStatus] = useState(null);

  const run = (minify) => {
    if (!text.trim()) return;
    try {
      const parsed = JSON.parse(text);
      setText(minify ? JSON.stringify(parsed) : JSON.stringify(parsed, null, indent));
      setStatus({ ok: true, message: t('useful.json.valid') });
    } catch (error) {
      setStatus({ ok: false, message: error.message });
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className={labelClass(isDarkMode)} htmlFor="json-input">
          JSON
        </label>
        <textarea
          id="json-input"
          value={text}
          onChange={(event) => { setText(event.target.value); setStatus(null); }}
          rows={12}
          placeholder={SAMPLE}
          spellCheck={false}
          className={`${fieldClass(isDarkMode)} resize-y font-mono text-sm`}
        />
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => run(false)} disabled={!text.trim()} className={buttonClass(isDarkMode, 'primary')}>
          {t('useful.json.format')}
        </button>
        <button type="button" onClick={() => run(true)} disabled={!text.trim()} className={buttonClass(isDarkMode)}>
          {t('useful.json.minify')}
        </button>
        <span className={`text-xs ml-1 ${mutedClass(isDarkMode)}`}>{t('useful.json.indent')}</span>
        {INDENTS.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => setIndent(option)}
            className={tabClass(isDarkMode, indent === option)}
          >
            {option}
          </button>
        ))}
        <CopyButton value={text} />
        <button type="button" onClick={() => setText(SAMPLE)} className={buttonClass(isDarkMode)}>
          {t('useful.json.sample')}
        </button>
      </div>

      {status && (
        <p className={`flex items-start gap-2 text-sm ${status.ok ? 'text-emerald-500' : 'text-red-500'}`}>
          {status.ok ? <FaCheckCircle className="mt-1 flex-none" /> : <FaExclamationCircle className="mt-1 flex-none" />}
          <span className="font-mono break-all">{status.message}</span>
        </p>
      )}
    </div>
  );
};

export default JsonFormatter;
